import { DialogBackdrop, Dialog as HeadlessDialog } from "@headlessui/react";

const Dialog = ({ isOpen = false, setIsOpen, children }: any) => {
  return (
    <HeadlessDialog
      open={isOpen}
      onClose={() => setIsOpen(false)}
      className="relative z-50"
    >
      <DialogBackdrop className="fixed inset-0 bg-[#052437]/20 backdrop-blur-[20px]" />
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
        {children}
      </div>
    </HeadlessDialog>
  );
};

export default Dialog;
